import Contexts from './Contexts.js';
import CampaignContextBuilder from './contexts/builders/Campaign.js';
import ReturningUsersBuilder from './contexts/builders/ReturningUsers.js';
import GlobalContextFinder from './GlobalContextFinder.js';
import Gateway from './Gateway.js';

export default class GlobalContexts extends Contexts {
  constructor() {
    super();
  }

  importFromAutoV10(pendingEvents) {
    if (Gateway.isAutoV10) {
      Gateway.autoRequire(['snowPlow/tagger'], this.getCallback(pendingEvents));
    } else {
      this._addSelfBuiltContexts();
    }
  }

  getCallback(pendingEvents) {
    return (tagger) => {
      tagger.globalContexts.forEach(contextData => this._addAutoV10Context(contextData));
      pendingEvents.releaseEvents();
    };
  }

  _addAutoV10Context(contextData) {
    try {
      const context = GlobalContextFinder.find(contextData.schema);
      this.add(context.import(contextData));
    } catch (e) {
      Gateway.window.console.warn(e.message);
    }
  }

  _addSelfBuiltContexts() {
    const builders = [];
    builders.push(new CampaignContextBuilder());
    builders.push(new ReturningUsersBuilder());
    builders.forEach(builder => builder.isEmpty() || this.add(builder.context));
  }
}
